
import React from 'react';

const ChevronsDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" d="m7 6 5 5 5-5" />
        <path strokeLinecap="round" strokeLinejoin="round" d="m7 13 5 5 5-5" />
    </svg>
);

export default ChevronsDownIcon;
